

export default function Header () {
    return (
        <div className="header">
            <h1>  </h1>

        </div>
    )
}

